import { Phone, MessageCircle, MapPin, Instagram, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { BRAND, LOGO_URL } from "@/lib/constants";

const Footer = () => {
  const { t, lang } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-white/10 bg-[#070707]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <span className="bg-white rounded-2xl px-3 py-1.5 inline-flex items-center mb-5">
            <img src={LOGO_URL} alt="Dent Xpress" className="h-10 w-auto" />
          </span>
          <p className="text-white/60 text-sm leading-relaxed max-w-xs">
            {t.footer.tagline}
          </p>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.25em] uppercase font-display text-white/50 mb-4">
            {t.nav.location}
          </h4>
          <p className="text-white/75 inline-flex items-center gap-2">
            <MapPin className="w-4 h-4 text-[#e10600]" /> {BRAND.addressEn}
          </p>
          <a
            href={BRAND.mapsLink}
            target="_blank"
            rel="noreferrer"
            className="mt-3 inline-block text-sm text-white/60 hover:text-white underline-offset-4 hover:underline"
            data-testid="footer-maps-link"
          >
            {t.common.openInGoogleMaps}
          </a>
        </div>

        <div>
          <h4 className="text-xs tracking-[0.25em] uppercase font-display text-white/50 mb-4">
            {t.nav.contact}
          </h4>
          <div className="flex flex-col gap-2">
            <a
              href={BRAND.whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-white/85 hover:text-white"
              data-testid="footer-whatsapp-link"
            >
              <MessageCircle className="w-4 h-4 text-[#e10600]" />
              {t.common.whatsapp}: {BRAND.whatsappNumberLocal}
            </a>
            <a
              href={BRAND.telLink}
              className="inline-flex items-center gap-2 text-white/85 hover:text-white"
              data-testid="footer-call-link"
            >
              <Phone className="w-4 h-4 text-[#e10600]" />
              {t.common.call}: {BRAND.phone}
            </a>
            <a
              href={BRAND.shopTelLink}
              className="inline-flex items-center gap-2 text-white/85 hover:text-white"
              data-testid="footer-shop-call-link"
            >
              <Phone className="w-4 h-4 text-[#e10600]" />
              {t.contact.shopLabel}: 24837666
            </a>
            <a
              href={BRAND.emailLink}
              className="inline-flex items-center gap-2 text-white/85 hover:text-white"
              data-testid="footer-email-link"
            >
              <Mail className="w-4 h-4 text-[#e10600]" />
              {BRAND.email}
            </a>
            <a
              href={BRAND.instagramLink}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-white/85 hover:text-white"
              data-testid="footer-instagram-link"
            >
              <Instagram className="w-4 h-4 text-[#e10600]" />
              {BRAND.instagramHandle}
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>© {year} {BRAND.name}. {t.footer.rights}</p>
          <Link
            to="/privacy"
            className="text-white/50 hover:text-white underline-offset-4 hover:underline"
            data-testid="footer-privacy-link"
          >
            {lang === "ar" ? "سياسة الخصوصية" : "Privacy Policy"}
          </Link>
          <p className="tracking-[0.2em] uppercase font-display">Shuwaikh · Kuwait</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
